import { Location } from '@angular/common';
import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { delay, takeUntil } from 'rxjs/operators';
import { of, Subject } from 'rxjs';
import { CloudAuthenticationService } from 'src/app/services/cloud-authentication.service';
import { MarketplaceTokenRequest } from 'src/app/models/marketplace-token-request.model';
import { CloudNotificationStyle } from 'src/app/models/cloud-notification-style.model';
import { CloudNotificationService } from 'src/app/services/cloud-notification.service';
import { SubscriptionRequest } from 'src/app/models/subscription-request.model';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import Helper from 'src/app/Util/helper';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CloudSubscriptionService } from 'src/app/cloud-subscription/services/cloud-subscription.service';
import { CloudDeploymentService } from 'src/app/cloud-subscription/services/cloud-deployment.service';
import { FreeTrialExpiryResponse } from 'src/app/models/responses/free-trial-expiry-response.model';
import { OTPVerificationRequest } from 'src/app/models/requests/otp-verification-request';
import { SubscriptionCreateService } from 'src/app/cloud-subscription/components/subscription-create/services/subscription-create.service';
import { MarketPlaceOffer } from 'src/app/interfaces/plan.interface';
import { CreateSubscriptionRequest, CreateSubscriptionResponse } from 'src/app/interfaces/subscription.interface';
import { LocalStorageService } from 'src/app/services/localstorage.service';
import { AuthUtils } from 'src/app/Util/auth-utils';
import { CloudProfileService } from 'src/app/services/cloud-profile.service';
import { StorageKeys } from 'src/app/Util/storage-keys';
import { ActivateSubscriptionRequest } from 'src/app/interfaces/services/subscription.interface';
import { API_ERRORS, SUCCESS } from 'src/app/Util/constants';

@Component({
  selector: 'app-enter-password-login',
  templateUrl: './enter-password-login.component.html',
  styleUrls: ['./enter-password-login.component.sass']
})
export class EnterPasswordLoginComponent implements OnInit {

  @Input() cloudPlanResponse: MarketPlaceOffer;
  passwordFormGroup: FormGroup;
  isActivatingPlan: boolean = false;
  vendor: string | undefined;
  stateId: string | undefined;
  subscriptionType: string | undefined;
  cloudOfferDisplayName: string = ''
  loading = false;
  submitted = false;
  email: string = '';
  password: string = '';
  cloudSubscription: CreateSubscriptionResponse;
  freeTrialExpiry: string;
  modelEvent: any;
  verificationOTP: string;
  otpVerifyDisabled = true;
  verifyOtpLoading: boolean = false;
  resendOtpLoading: boolean = false;
  otpResendDuration: number = 0;
  resendSuccessful: boolean = false;
  resendAllowed: boolean = true;
  faCheckCircle = faCheckCircle;
  successfulRegistrationModalStepOne: boolean = true;
  private userFeched = new Subject<boolean>()
  cloudPlanPeriod = '';

  @ViewChild('creatingSubscription') creatingSubscription: TemplateRef<any>;
  @ViewChild('successfulRegistrationModal') successfulRegistrationModal: any;
  @ViewChild('successfulRegistrationPaidModal') successfulRegistrationPaidModal: any;


  unsubscribeSubject = new Subject();
  subscriptionUid: string;
  planDetail: MarketPlaceOffer;

  constructor(private notificationSvc: CloudNotificationService,
    private readonly localStorage: LocalStorageService,
    private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute,
    private location: Location, private modalSvc: NgbModal, private subscriptionSvc: CloudSubscriptionService,
    private authSvc: CloudAuthenticationService, public componentService: CloudDeploymentService,
    private profileSvc: CloudProfileService,
    private subscriptionCreateSvc: SubscriptionCreateService) {
    this.cloudPlanPeriod = this.subscriptionCreateSvc.cloudPlanResponse.period;

  }

  private getRouteStateData() {
    this.cloudOfferDisplayName = history.state.cloudOfferDisplayName
  }

  ngOnInit() {
    this.route.queryParams.subscribe(queryParams => {
      this.email = queryParams.email ? atob(queryParams.email) : '';
      this.stateId = queryParams.stateId ? queryParams.stateId : '';
      this.vendor = queryParams.vendor ? queryParams.vendor : '';
    });
    this.getRouteStateData()
    this.observeUserFetched()
    this.initializePasswordForm();
  }

  private initializePasswordForm(): void {
    this.passwordFormGroup = this.formBuilder.group({ password: ['', [Validators.required]] })
  }

  get f() {
    return this.passwordFormGroup.controls
  }

  onSubmit(verificationOTPModal: any) {

    this.submitted = true;
    // stop here if form is invalid
    if (this.passwordFormGroup.invalid) {
      return;
    }
    this.loading = true;
    this.modelEvent = verificationOTPModal;

    this.password = this.f.password.value;

    //64 bit encoding of email and password fields
    var encoded_email = btoa(this.email);
    var encoded_password = btoa(this.password);

    //Concatinating the email and password with '.'
    var concated_code = encoded_email + '.' + encoded_password;

    var tokenRequest = new MarketplaceTokenRequest();
    var cloudVendor = Helper.getVendor(this.vendor);

    tokenRequest.token = this.stateId;
    tokenRequest.vendor = cloudVendor.vendorName;

    let createSubscriptionRequest: CreateSubscriptionRequest = {
      marketPlaceToken: this.stateId,
      cloudVendor: this.vendor,
      authCode: concated_code
    }

    this.notificationSvc.createorUpdateToastNotification('new-susbcription',
      this.creatingSubscription, CloudNotificationStyle.info);

    this.subscriptionSvc.createSubscription(createSubscriptionRequest)
      .subscribe(
        (res) => {
          this.getUserDetails()
          this.subscriptionUid = res.subscription.id;
          this.cloudSubscription = res.subscription;
          this.paidSubscriptionRegistrationSucess()
        },
        (error) => {
          this.loading = false;
          this.createSubscriptionErrorHandler(error);
        }
      );
  }

  private observeUserFetched() {
    this.userFeched.subscribe((data) =>
      this.localStorage.setItemSessionStorage(StorageKeys.SubscriptionId, this.subscriptionUid)
    )
  }


  resolveAuthToken() {
    const authCode = AuthUtils.encodeEmailAndPassword(this.email, this.password);
    this.authSvc.resolveAuthToken({ code: authCode }, true).subscribe(() => {
      this.redirectToPlanSelection(this.cloudPlanPeriod);
      this.loading = false;
    },
      (error) => {
        this.loading = false;
        this.createSubscriptionErrorHandler(error);
      });
  }

  redirectToPlanSelection(period: string) {
    this.router.navigate([environment.routes.available_plans], { queryParams: { subscriptionId: this.subscriptionUid, period: period } });
    this.modalSvc.dismissAll(this.modelEvent);
  }


  goToDashboard() {
    this.modalSvc.dismissAll();
    this.router.navigate([environment.routes.subscription]);
  };

  verifyOTP(): void {

    this.verifyOtpLoading = true;
    let request = new OTPVerificationRequest();
    request.email = this.email;
    request.otp = this.verificationOTP;

    this.notificationSvc.removeToastNotification('new-subscriber');

    this.subscriptionSvc.verifyOTP(this.email, this.verificationOTP).pipe(takeUntil(this.unsubscribeSubject)).subscribe(res => {
      this.closeModal();

      this.localStorage.removeItem('alreadyRegisteredRadio');
      this.localStorage.removeItem('email');

      this.notificationSvc.createorUpdateToastNotification('otp-verified', res, CloudNotificationStyle.success);
      var encoded_email = btoa(this.email);
      var encoded_password = btoa(this.password);
      var concated_code = encoded_email + '.' + encoded_password;

      this.authSvc.resolveAuthToken({ code: concated_code }, true).subscribe(() => {
        this.paidSubscriptionRegistrationSucess();
      },
        error => {
          const regex = /(account|email)[a-zA-Z0-9 $!.]*not[a-zA-Z0-9 $!.]*verified/g;
          if ((Helper.resolveErrorMessage(error) as string).toLowerCase().match(regex)) {
            this.openModal(this.modelEvent, 'verificationOTPModal');
          }
        });

    }, err => {
      this.verifyOtpLoading = false;
      this.otpVerifyDisabled = false;
      this.notificationSvc.createToastNotification(
        'new-subscriber',
        Helper.resolveErrorMessage(err),
        CloudNotificationStyle.danger
      );
    });
  }

  private getSubscriptionId(): string {
    return this.localStorage.getItemSessionStorage(StorageKeys.SubscriptionId)
  }

  private getUserDetails() {
    if (this.getSubscriptionId()) {
      this.profileSvc.getUserDetails().subscribe({
        next: (res) => {
          if (res.email != this.email) {
            this.logoutUser()
          }
          this.userFeched.next(true)
        },
        error: (err) => {

        }
      })
    }
  }

  private logoutUser() {
    this.authSvc.logout(false, false, false, false)
  }


  resendOTP(): void {

    this.resendSuccessful = false;
    this.resendOtpLoading = true;
    let request = new OTPVerificationRequest();
    request.email = this.email;

    this.subscriptionSvc.resendOTP(this.email).pipe(takeUntil(this.unsubscribeSubject)).subscribe(res => {

      this.resendOtpLoading = false;
      this.resendSuccessful = true;
      this.resendAllowed = false;
      this.otpResendDuration = 60;

      let otpInterval = setInterval(() => {
        if (this.otpResendDuration > 0) this.otpResendDuration--;
        if (this.otpResendDuration === 0) clearInterval(otpInterval);
      }, 1000);

      this.notificationSvc.createToastNotification(
        'new-subscriber',
        res,
        CloudNotificationStyle.success
      );
    },
      (error) => {

        this.resendOtpLoading = false;
        this.otpResendDuration = Helper.resolveErrorMessage(error);

        let otpInterval = setInterval(() => {
          if (this.otpResendDuration > 0) this.otpResendDuration--;
          if (this.otpResendDuration === 0) clearInterval(otpInterval);
        }, 1000);

        this.notificationSvc.createToastNotification(
          'registration',
          `You are not allowed to resend OTP again. Please wait for ${this.otpResendDuration} seconds.`,
          CloudNotificationStyle.danger
        );
      });
  }

  verificationOTPConsentChange(value: string) {
    this.otpVerifyDisabled = value !== '' ? false : true;
    this.verificationOTP = value;
  }

  openModal(modal, modalName: string = '') {
    if (modalName === 'verificationOTPModal')
      this.modalSvc.open(modal, { windowClass: 'verificationOTPModal', backdrop: 'static', keyboard: false, centered: true });
    else if (modalName === 'successfulRegistrationModal')
      this.modalSvc.open(modal, { windowClass: 'successfulRegistrationModal', backdrop: 'static', keyboard: false, centered: true });
    else
      this.modalSvc.open(modal, { backdrop: 'static', keyboard: false, centered: true });
  }


  private createSubscriptionErrorHandler(error: any) {
    this.notificationSvc.removeToastNotification('new-susbcription');
    const regex = /(account|email)[a-zA-Z0-9 $!.]*not[a-zA-Z0-9 $!.]*verified/g;
    if ((Helper.resolveErrorMessage(error) as string).toLowerCase().match(regex)) {
      this.openModal(this.modelEvent, 'verificationOTPModal');
    } else {
      this.notificationSvc.createToastNotification('new-susbcription', Helper.resolveErrorMessage(error), CloudNotificationStyle.danger);
    }
  }

  getFreeTrialExpiry(subsciptionUid) {
    this.componentService.getFreeTrialExpiryDate(subsciptionUid).subscribe((res: FreeTrialExpiryResponse) => {
      this.freeTrialExpiry = Object.keys(res).length === 0 && res.constructor === Object ? '' : this.subscriptionSvc.formatDate(res.expiryDate);
      this.openModal(this.successfulRegistrationModal, 'successfulRegistrationModal');
    }, error => {
      this.notificationSvc.createorUpdateToastNotification('new-subscriber', 'Error: ' + Helper.resolveErrorMessage(error), CloudNotificationStyle.danger);
    })
  }

  isAzureVendor(): boolean {
    return Helper.getVendor(this.vendor).vendorName === 'azure' ? true : false;
  }

  paidSubscriptionRegistrationSucess() {
    this.openModal(this.successfulRegistrationPaidModal, 'successfulRegistrationModal');
  }

  redirectToDashboard() {
    this.router.navigate([environment.routes.subscription]);
    this.modalSvc.dismissAll(this.modelEvent);
  }

  redirectToPaidOptions() {
    this.router.navigate([environment.routes.quotation], { queryParams: { subscriptionId: this.cloudSubscription.id } });
    this.modalSvc.dismissAll(this.modelEvent);
  }

  closeModal() {
    this.modalSvc.dismissAll();
  }

  redirectToPreviousPage(e: Event) {
    e.preventDefault()
    this.location.back();
  }
}
